import { get } from '@kit/utils/APIV1.js'

export const byID = async(id) => {
  return get(`location/id/${id}`)
}
export const bySlug = async(slug) => {
  return get(`location/slug/${slug}`)
}
export const all = async() => {
  return get(`locations/all/short`)
}